import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseLayoutComponent } from '@libraries/design-system';
import { CanNavigateGuard } from './guards/can-navigate.guard';
import { HeaderWrapperComponent } from './header-wrapper/header-wrapper.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { PropertyIsEligibleComponent } from './property-is-eligible/property-is-eligible.component';
import { PropertyNotEligibleComponent } from './property-not-eligible/property-not-eligible.component';

export const routes: Routes = [
  {
    path: '',
    component: BaseLayoutComponent,
    children: [
      {
        path: '',
        outlet: 'header',
        component: HeaderWrapperComponent,
      },
      {
        path: '',
        pathMatch: 'full',
        component: LandingPageComponent,
      },
      {
        path: 'eligible',
        component: PropertyIsEligibleComponent,
        canActivate: [CanNavigateGuard],
      },
      {
        path: 'not-eligible',
        component: PropertyNotEligibleComponent,
        canActivate: [CanNavigateGuard],
      },
      {
        path: ':id',
        component: LandingPageComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
